<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col class="common-card-col">
        <v-row no-gutters>
          <v-col cols="12" sm="4" class="text-h6 pt-1 titleLight--text"> Journeys Overview </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="4" lg="2">
            <InputSelectVT
              height="32"
              :items="page_content.journeys_overview_select"
              @value_changes="get_journeys($event)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="common-card-row">
      <v-col class="pa-0 pr-md-3" cols="12" md="10">
        <v-col class="common-card-col">
          <div class="text-h6 primaryDark--text pt-3">Assets Journey Distribution</div>
          <LineChartVT v-if="graph_data" :chartData="graph_data" ylabel="Volume of Assets" xlabel="Dates" />
        </v-col>
      </v-col>
      <v-col class="pa-0" cols="12" md="2">
        <v-col class="common-card-col">
          <div
            class="d-flex justify-space-between my-3"
            v-for="(item, index) in page_content.journey_overview_stats"
            :key="`${item.value}_${index}`"
          >
            <div class="ma-1">
              <div class="text-caption">{{ item.label }}</div>
              <div class="primaryDark--text text-h6">
                {{ item.type == "number" ? $numberWithCommas(current_stat[item.value]) : current_stat[item.value] }}
              </div>
            </div>
            <div class="ma-1 mr-0">
              <v-chip class="opaque-img px-4 py-7" :color="`${item.color} lighten-4`" label :text-color="item.color">
                <v-icon>{{ item.icon }}</v-icon>
              </v-chip>
            </div>
          </div>
        </v-col>
      </v-col>
    </v-row>

    <v-row class="common-card-row pb-3">
      <v-col class="common-card-col">
        <v-row>
          <v-col cols="12" sm="3">
            <PrimaryFiltersVT
              :list_filters="page_content.filters.primary"
              @filter_update="filter_list($event)"
              :current_tab="current_tab"
            ></PrimaryFiltersVT>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row class="pt-3" no-gutters>
              <v-col cols="5">
                <v-select dense v-model="origin" :items="origins" label="Origin" @change="filter_list('All')"></v-select
              ></v-col>
              <v-col cols="2" class="text-center text-subtitle-2">to</v-col>
              <v-col cols="5"
                ><v-select
                  dense
                  v-model="destination"
                  :items="destinations"
                  label="Destination"
                  @change="filter_list('All')"
                ></v-select
              ></v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="3" class="text-right">
            <SecondaryFiltersVT
              :filters="updated_config"
              @clear_filters="clear_filters"
              @apply_filters="apply_filters($event)"
            ></SecondaryFiltersVT>
          </v-col>
        </v-row>
        <DataTableVT
          :headers="page_content.journeys_table"
          :items_list="filtered_journeys"
          sort_by="TotalAssets"
          @rowClick="open_details($event)"
          @add-to-list="watchlist_update($event)"
        />
      </v-col>
    </v-row>

    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        class="backgroundLight"
        style="width: 80vw; max-height: 80vh; overflow: auto"
      >
        <div class="close-btn">
          <v-btn class="py-4" outlined x-small color="restingOutline" right @click="closeDialog">
            <v-icon small color="primaryGrey">close</v-icon>
          </v-btn>
        </div>
        <div class="pa-0" style="overflow: auto; height: 100%; max-width: 100%">
          <Journey :JourneyID="journey_id" :week="week" />
        </div>
      </v-card>
    </v-overlay>
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ error_message }}</v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import Journey from "../views/Journey";
import DataTableVT from "../components/DataTableVT";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import SecondaryFiltersVT from "../components/SecondaryFiltersVT";
import InputSelectVT from "../components/InputSelectVT";
import LineChartVT from "../components/LineChartVT";
import { axios_post, axios_delete } from "../services/vt_service";
import { tracking } from "../services/tracking";
import { content } from "../../config/journeys.js";
import { redirect_to_asset } from "../helpers/helpers";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];

export default {
  name: "Journeys",
  components: {
    Journey,
    DataTableVT,
    PrimaryFiltersVT,
    SecondaryFiltersVT,
    InputSelectVT,
    LineChartVT,
  },
  data: function () {
    return {
      snackbar: false,
      page_content: null,
      location_details: {},
      network_error: false,
      journeys_data: [],
      stats_data: [],
      error_message: "",
      formated_journeys_data: null,
      locations_array: [],
      panel: [],
      search: "",
      dialog: false,
      expanded: [],
      current_sort_dir: "asc",
      current_sort: "LocationName",
      location_overview_stats: {},
      watchlist: [],
      filter_conditions: {},
      primary_filter_conditions: "",
      current_stat: {},
      filtered_journeys: [],
      max_at_destination: 0,
      max_total_assets: 0,
      graph_data: null,
      width: "0",
      week: 4,
      origin: "All",
      destination: "All",
      origins: [],
      destinations: [],
      current_tab: "All",
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    // this.$store.commit("update_page_title", "Journeys");
    this.get_journeys(4, true);
  },
  filters: {},
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    clear_filters: function () {
      this.filter_conditions = {};
      this.filter_list("All");
    },
    apply_filters: function (filters) {
      this.filter_conditions = filters;
      this.filter_list("All");
    },
    open_details(location_obj) {
      if (location_obj.ctrlKey)
        return redirect_to_asset(this.$router, "Journey", location_obj.OriginID, location_obj.DestinationID, this.week);
      this.location_details = location_obj;
      this.dialog = true;
    },
    watchlist_update(item) {
      item["IsWatchlisted"] ? this.delete_from_watchlist(item) : this.add_to_watchlist(item);
    },
    get_position(lat, lng) {
      return {
        lat: lat,
        lng: lng,
      };
    },
    async delete_from_watchlist(item) {
      var data = {
        OriginID: item["OriginID"],
        DestinationID: item["DestinationID"],
      };
      this.network_error = false;
      await axios_delete(tracking.delete_from_watchlist_journeys, {}, data);
      this.watchlist = this.watchlist.filter((elem) => {
        return !(item["OriginID"] == elem["OriginID"] && ["DestinationID"] == elem["DestinationID"]);
      });
      this.journeys_data = this.journeys_data.map((elem) => {
        if (elem["OriginID"] == item["OriginID"] && elem["DestinationID"] == item["DestinationID"])
          elem["IsWatchlisted"] = false;
        return elem;
      });
      item["IsWatchlisted"] = false;
    },
    get_current_stats(stats_type) {
      let OriginLocationType,
        AvgStayDuration = 0,
        FleetUtilisation = 0,
        TotalAssets = 0;
      if (stats_type == "All") {
        OriginLocationType = "All";
        for (var i = 0; i < this.stats_data.length; i++) {
          AvgStayDuration = AvgStayDuration + this.stats_data[i]["AvgStayDuration"];
          FleetUtilisation = FleetUtilisation + this.stats_data[i]["FleetUtilisation"];
          TotalAssets = TotalAssets + this.stats_data[i]["TotalAssets"];
        }
        AvgStayDuration = Math.round((AvgStayDuration / this.stats_data.length) * 100) / 100 + " hours";
        FleetUtilisation = Math.round((FleetUtilisation / this.stats_data.length) * 100) + "%";
      }
      this.current_stat = {
        OriginLocationType,
        AvgStayDuration,
        FleetUtilisation,
        TotalAssets,
      };
    },
    filter_list(filter) {
      let range_filter = {};
      if (filter) this.current_tab = filter;
      if (this.filter_conditions.range) {
        for (var key of Object.keys(this.filter_conditions.range)) {
          let temp = key.split("_");
          let field = temp[1];
          range_filter[temp[0]] = range_filter[temp[0]] || {};
          range_filter[temp[0]][field] = this.filter_conditions["range"][key];
        }
      }
      this.filtered_journeys = this.journeys_data.filter((elem) => {
        let filtered =
          elem["DestinationName"].toLowerCase() != "outside pois" &&
          elem["DestinationName"].toLowerCase() != "no location data" &&
          ((filter == "Watchlist" && elem["IsWatchlisted"] == true) || filter == "All");
        if (this.origin != "All") filtered = filtered && this.origin == elem.OriginName;
        if (this.destination != "All") filtered = filtered && this.destination == elem.DestinationName;
        if (this.filter_conditions.checkbox) {
          for (var key of Object.keys(this.filter_conditions.checkbox)) {
            if (this.filter_conditions.checkbox[key].length > 0)
              filtered = filtered && elem[key] == this.filter_conditions.checkbox[key];
          }
        }
        if (range_filter) {
          for (var item of Object.keys(range_filter)) {
            if (range_filter[item].min != 0 && range_filter[item].max != 0)
              filtered = filtered && elem[item] >= range_filter[item].min && elem[item] <= range_filter[item].max;
          }
        }
        return filtered;
      });
    },
    async add_to_watchlist(item) {
      var data = {
        OriginID: item["OriginID"],
        DestinationID: item["DestinationID"],
      };
      this.network_error = false;
      await axios_post(tracking.add_to_watchlist_journeys, data);
      item["IsWatchlisted"] = true;
      this.journeys_data = this.journeys_data.map((elem) => {
        if (elem["OriginID"] == item["OriginID"] && elem["DestinationID"] == item["DestinationID"])
          elem["IsWatchlisted"] = true;
        return elem;
      });
      this.watchlist.push({
        OriginID: item["OriginID"],
        DestinationID: item["DestinationID"],
      });
    },
    async get_journeys(week = 1, fetch_watchlist = false) {
      //this.$store.commit("show_loader");
      this.current_tab = "All";
      this.week = week;
      this.origin = "All";
      this.destination = "All";
      var new_graph_config = [
        [
          "Assets Journey Distribution",
          "To Friendly POIs",
          "To Non Friendly POIs",
          "Outside POIs",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
      ];
      this.network_error = false;
      const accessToken = await this.$auth.getTokenSilently();
      this.network_error = false;
      var self = this;
      const tenant = this.$auth.user[tenant_key]["tenant"];
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      let journeys_req = axios.get(`${api_root}/api/journey/${week}`, header);
      let stats_req = axios.get(`${api_root}/api/journey/stats/${week}`, header);
      let watchlist_req = axios.get(`${api_root}/api/watchlist/journey`, header);
      let graphs_req = axios.get(`${api_root}/api/journey/graph/${week}`, header);
      let all_req = [journeys_req, stats_req, graphs_req];
      fetch_watchlist && all_req.push(watchlist_req);
      axios
        .all(all_req)
        .then(
          axios.spread((...responses) => {
            let journeys_data = responses[0].data;
            self.stats_data = responses[1].data;

            let weeks_ago = {};
            for (var i = 0; i < responses[2].data.length; i++) {
              if (!weeks_ago[responses[2].data[i]["WeeksAgo"]]) weeks_ago[responses[2].data[i]["WeeksAgo"]] = [];
              weeks_ago[responses[2].data[i]["WeeksAgo"]].push(responses[2].data[i]);
            }
            self.graph_data = new_graph_config;
            for (var key of Object.keys(weeks_ago)) {
              let tempObj = {
                WeeksAgo: null,
                Friendly: 0,
                "Non Friendly": 0,
                "Outside POIs": 0,
                "No location data": 0,
              };
              tempObj["WeeksAgo"] = key;
              for (var j = 0; j < weeks_ago[key].length; j++) {
                tempObj[weeks_ago[key][j]["LocationType"]] = weeks_ago[key][j]["TotalAssets"];
              }
              var startDate = new Date(weeks_ago[key][0]["StartDate"]);
              var endDate = new Date(weeks_ago[key][0]["StartDate"]);
              endDate.setDate(startDate.getDate() + 7);
              self.graph_data.push([
                startDate.toLocaleString().split(",")[0] + " - " + endDate.toLocaleString().split(",")[0],
                tempObj["Friendly"],
                tempObj["Non Friendly"],
                tempObj["Outside POIs"] + tempObj["No location data"],
                "",
              ]);
            }
            self.watchlist = fetch_watchlist ? responses[3].data : self.watchlist;
            this.origins = ["All"];
            this.destinations = ["All"];
            self.journeys_data = journeys_data
              .map((elem) => {
                this.origins.indexOf(elem.OriginName) == -1 &&
                  elem["OriginName"].toLowerCase() != "outside pois" &&
                  elem["OriginName"].toLowerCase() != "no location data" &&
                  this.origins.push(elem.OriginName);
                this.destinations.indexOf(elem.DestinationName) == -1 &&
                  elem["DestinationName"].toLowerCase() != "outside pois" &&
                  elem["DestinationName"].toLowerCase() != "no location data" &&
                  this.destinations.push(elem.DestinationName);
                this.max_at_destination =
                  this.max_at_destination > elem["AtDestination"] ? this.max_at_destination : elem["AtDestination"];
                this.max_total_assets =
                  this.max_total_assets > elem["TotalAssets"] ? this.max_total_assets : elem["TotalAssets"];

                let filtered = self.watchlist.filter((val) => {
                  return elem["OriginID"] == val["OriginID"] && elem["DestinationID"] == val["DestinationID"];
                });
                elem.IsWatchlisted = filtered.length > 0 ? true : false;
                self.get_current_stats("All");
                return elem;
              })
              .filter((elem) => {
                return (
                  elem["DestinationName"].toLowerCase() != "outside pois" &&
                  elem["DestinationName"].toLowerCase() != "no location data"
                );
              });
            this.origins.sort();
            this.destinations.sort();
            self.filtered_journeys = JSON.parse(JSON.stringify(self.journeys_data));
            //self.$store.commit("hide_loader");
          })
        )
        .catch((e) => {
          //self.$store.commit("hide_loader");
          self.network_error = true;
          console.log(e);
        });
    },
    update_locations_watchlist() {
      this.journeys_data.map((elem) => {
        elem.IsWatchlisted = this.watchlist.indexOf(elem.LocationID) != -1 ? true : false;
        return elem;
      });
    },
  },
  computed: {
    updated_config: function () {
      this.page_content.filters.secondary.range.map((elem) => {
        if (elem["value"] == "AtDestination") elem["max"] = this.max_at_destination;
        else elem["max"] = this.max_total_assets;
      });
      return this.page_content.filters.secondary;
    },
    journey_id: function () {
      return [this.location_details["OriginID"], this.location_details["DestinationID"]];
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .right-border {
  border-right: 1px solid var(--v-border-base);
}
.opaque-img {
  opacity: 0.7;
}
.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}
.map-close-button {
  position: absolute;
  z-index: 5;
}
.border-right {
  border-right: 1px solid var(--v-primaryGrey-base);
}
.border-bottom {
  border-bottom: 1px solid var(--v-primaryGrey-base);
}
.fixed-height {
  max-height: 70vh;
  overflow: auto;
}
</style>
